export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7998.2a6b2dbc.jpg";